import MainLayout from '../layout';
import DashboardDefault from "../pages/default";
import UserListPage from "../pages/User/UserListPage";
import AddUserPage from "../pages/User/AddUserPage";
import ModifyUserPage from "../pages/User/ModifyUserPage";
import TreadErlichPage from "../pages/Tread/TreadErlichPage";
import BikeplusErlichPage from "../pages/Bikeplus/BikeplusErlichPage";
import FileLimitPage from "../pages/File/FileLimitPage";
import AddFileLimitPage from "../pages/File/AddFileLimitPage";
import ModifyFileLimitPage from "../pages/File/ModifyFileLimitPage";
import CaesarErlichPage from "../pages/Caesar/CaesarErlichPage";
import StableBuildPage from "../pages/Passerine/StableBuildPage";
import SwallowIPAddPage from "../pages/Passerine/SwallowIPAddPage";
import SwallowIPPage from "../pages/Passerine/SwallowIPPage";
import SwallowModifyPage from "../pages/Passerine/SwallowModifyPage";
import TestQueuePage from "../pages/Passerine/TestQueuePage";
import TestDetialPage from "../pages/Passerine/TestDetialPage";
import TestCombinationsPage from "../pages/Passerine/TestCombinationsPage";
import TestAutomationPage from "../pages/Automation/TestAutomationPage";
import TestAutomationFilterPage from "../pages/Automation/TestAutomationFilterPage";
import OTATestFilterPage from "../pages/Automation/OTATestFilterPage";
import AmberExternalPage from "../pages/Automation/AmberExternalPage";
import PerformancePage from "../pages/Automation/PerformancePage";
import PerformanceHistoryPage from "../pages/Automation/PerformanceHistoryPage";
import PerformanceRawDataPage from "../pages/Automation/PerformanceRawDataPage";
import TestItemFilterPage from "../pages/Automation/TestItemFilterPage";
import FactoryImageSelectionPage from "../pages/Automation/FactoryImageSelectionPage";
import TestRailCaseInfoPage from "../pages/Automation/TestRailCaseInfoPage";
import TestRailSYSAutomatedInfoPage from "../pages/Automation/TestRailSYSAutomatedInfoPage";
import TestRailOtherAutomatedInfoPage from "../pages/Automation/TestRailOtherAutomatedInfoPage";
import XrayCFXAppAutomatedInfoPage from "../pages/Automation/XrayCFXAppAutomatedInfoPage";
import IgnoreAutomationReportPage from "../pages/Automation/IgnoreAutomationReportPage";
import VoiceQueuePage from "../pages/Passerine/VoiceQueuePage";
import VoiceTestPage from "../pages/Passerine/VoiceTestPage";
import BBroPage from "../pages/SelfDiag/BBroPage";
import NestlingUploadPage from "../pages/Nestling/NestlingUploadPage";
import NestlingPlusPage from "../pages/Nestling/NestlingPlusPage";
import NestlingQueuePage from "../pages/Nestling/NestlingQueuePage";
import NestlingPlusQueuePage from "../pages/Nestling/NestlingPlusQueuePage";


const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: 'dashboard',
            element: <DashboardDefault />
        },
        {
            path: '/callback',
            element: <DashboardDefault />
        },
        {
            path: '/user-list',
            element: <UserListPage />
        },
        {
            path: '/add-user',
            element: <AddUserPage />
        },
        {
            path: '/modify-user/:uuid',
            element: <ModifyUserPage />
        },
        {
            path: '/tread-erlich',
            element: <TreadErlichPage />
        },
        {
            path: '/bikeplus-erlich',
            element: <BikeplusErlichPage />
        },
        {
            path: '/file-limit',
            element: <FileLimitPage />
        },
        {
            path: '/add-file-limit',
            element: <AddFileLimitPage />
        },
        {
            path: '/edit-file-limit/:uuid',
            element: <ModifyFileLimitPage />
        },
        {
            path: '/caesar-erlich',
            element: <CaesarErlichPage />
        },
        {
            path: '/stable-builds',
            element: <StableBuildPage />
        },
        {
            path: '/swallow-settings',
            element: <SwallowIPPage />
        },
        {
            path: '/swallow-add-settings',
            element: <SwallowIPAddPage />
        },
        {
            path: '/swallow-modify-settings/:uuid',
            element: <SwallowModifyPage />
        },
        {
            path: '/test-queue',
            element: <TestQueuePage />
        },
        {
            path: '/test-detail/:token',
            element: <TestDetialPage />
        },
        {
            path: '/test-combinations',
            element: <TestCombinationsPage />
        },
        {
            path: '/test-automation',
            element: <TestAutomationPage />
        },
        {
            path: '/test-filter',
            element: <TestAutomationFilterPage />
        },
        {
            path: '/ota-test-filter',
            element: <OTATestFilterPage />
        },
        {
            path: '/voice-tests',
            element: <VoiceQueuePage />
        },
        {
            path: '/query-voice',
            element: <VoiceTestPage />
        },
        {
            path: '/bplus-bro',
            element: <BBroPage />
        },
        {
            path: '/amber-external',
            element: <AmberExternalPage />
        },
        {
            path: '/image-selection',
            element: <FactoryImageSelectionPage />
        },
        {
            path: '/performance',
            element: <PerformancePage />
        },
        {
            path: '/performance-history',
            element: <PerformanceHistoryPage />
        },
        {
            path: '/performance-raw-data',
            element: <PerformanceRawDataPage />
        },
        {
            path: '/nestling-upload',
            element: <NestlingUploadPage />
        },
        {
            path: '/nestling-plus',
            element: <NestlingPlusPage />
        },
        {
            path: '/nestling-queue',
            element: <NestlingQueuePage />
        },
        {
            path: '/nestling-plus-items',
            element: <NestlingPlusQueuePage />
        },
        {
            path: '/error-query',
            element: <TestItemFilterPage />
        },
        {
            path: '/testrail-case',
            element: <TestRailCaseInfoPage />
        },
        {
            path: '/ignore-report',
            element: <IgnoreAutomationReportPage />
        },
        {
            path: '/testrail-automated',
            element: <TestRailSYSAutomatedInfoPage />
        },
        {
            path: '/testrail-other-automated',
            element: <TestRailOtherAutomatedInfoPage />
        },
        {
            path: '/cfx-app-automated',
            element: <XrayCFXAppAutomatedInfoPage />
        }
    ]
};

export default MainRoutes;
